import { Star } from "lucide-react";

export const Marquee = () => {
  const items = Array.from({ length: 8 });
  return (
    <div className="relative border-y border-white/10 bg-[#0a0a0a] py-6 overflow-hidden" data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
            {items.map((_, i) => (
              <div key={i} className="flex items-center gap-6 px-6">
                <span className="font-display text-2xl md:text-4xl tracking-tight text-white/90">
                  @habibzdetailing
                </span>
                <Star size={22} className="text-[#0055ff]" fill="#0055ff" />
                <span className="font-mono text-xs uppercase tracking-[0.3em] text-white/40">
                  Clean · Protect · Perfect
                </span>
                <Star size={22} className="text-white/25" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
